import { debounce } from 'lodash';
import { useCallback } from 'react';

export const useDebounce = <F extends (...args: any[]) => any>(fn: F, delay: number) =>
  useCallback(debounce(fn, delay), []);
